/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 모바일의 시행사 정보입니다.
 * 이 컴포넌트에서 모바일에서 렌더되는 모든 항목의 렌더링을 제어할 수 있습니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import './index.scss';
import { dataCompany } from 'data/company';

const CompanyInfo = () => {
  return (
    <div className="detail-company">
    {
        dataCompany.map((value, idx) => {
            return (
            <div key={idx} style={{ fontSize: 12, paddingTop: 6 }} className="detail-company-container">
                <div className="detail-company-items">
                <span> { value.title } </span>
                <span className="detail"> { value.desc } </span>
                </div>
            </div>
            )
        })
    }   
    </div>
  );
};

export default CompanyInfo;
